export * from './configuration/davincilock.configuration.component';